import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ResultsHeader from './ResultsHeader';

/**
 * HOC for analytics results pages. Handles datepicker and filtering logic.
 */
const ResultsWrapper = (WrappedComponent) => {
  class Page extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        query: {
          page: 1,
          customerName: '',
          steps: [],
          startDate: undefined,
          endDate: undefined,
          userId: props.match.params.userId || '',
        },
      };
    }

    componentDidMount() {
      if (this.props.queryDate) {
        const { start, end } = this.props.queryDate;
        this.updateDateRange(start, end);
      }
    }

    // Calling the parent component callback fn to persist date
    updateDateOnRangeToggle = (startDate, endDate) => {
      this.props.onDateRangeChange(
        moment(startDate).toDate(),
        moment(endDate).toDate(),
      );
      // If we are not in a tab page, this attribute tells the component to fetch API calls in this component
      // else the callback above will trigger parent component to do the API calls.
      if (this.props.fetchLocal) {
        this.fetchDeals();
      }
    };

    /**
     * Update date range in state/query and re-fetch data.
     */
    /**
     * Update date range in state/query and re-fetch data.
     */
    updateDateRange = (startDate, endDate) => {
      this.updateQuery(
        {
          startDate: moment(startDate).toDate(),
          endDate: moment(endDate).toDate(),
          page: 1,
        },
        () => {
          // we make calls to api from child component
          if (this.props.fetchLocal) this.fetchDeals();
        },
      );
    };

    /**
     * Update customer name and re-fetch deals.
     */
    updateCustomerName = (customerName) => {
      this.updateQuery({ customerName, page: 1 }, this.fetchDeals);
    };

    /**
     * Update required steps and re-fetch deals.
     */
    updateFilteredSteps = (steps) => {
      this.updateQuery({ steps, page: 1 }, this.fetchDeals);
    };

    /**
     * Update page and re-fetch deals.
     */
    updatePage = (page) => {
      this.updateQuery({ page }, this.fetchDeals);
    };

    /**
     * Update query state.
     */
    updateQuery = (query, callback) => {
      this.setState({ query: { ...this.state.query, ...query } }, callback);
    };

    /**
     * Fetch analytics using query data from state.
     */
    fetchDeals = () => {
      this.props.fetchDeals({
        dealerId: this.props.dealer.id,
        userId: this.state.query.userId,
        customerName: this.state.query.customerName,
        startDate: this.props.queryDate?.start?.toISOString(),
        endDate: this.props.queryDate?.end?.toISOString(),
        steps: this.state.query.steps,
        page: this.state.query.page,
      });
    };

    render() {
      return (
        <div>
          <ResultsHeader
            startDate={this.props.queryDate?.start}
            endDate={this.props.queryDate?.end}
            onRangeChange={this.updateDateOnRangeToggle}
          />
          <WrappedComponent
            query={{
              ...this.state.query,
              startDate: this.props.queryDate?.start,
              endDate: this.props.queryDate?.end,
            }}
            dealer={this.props.dealer}
            updatePage={this.updatePage}
            updateCustomerName={this.updateCustomerName}
            updateFilteredSteps={this.updateFilteredSteps}
            {...this.props}
          />
        </div>
      );
    }
  }

  Page.defaultProps = {
    fetchAnalytics: () => {},
    fetchDeals: () => {},
  };

  Page.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
    queryDate: PropTypes.object,
    fetchLocal: PropTypes.bool,
    fetchAnalytics: PropTypes.func,
    fetchDeals: PropTypes.func,
    onDateRangeChange: PropTypes.func,
  };

  const mapStateToProps = ({ user }) => ({
    dealer: user.currentUserDealer,
  });

  return withRouter(connect(mapStateToProps)(Page));
};

export default ResultsWrapper;
